import React from 'react';
import { Tooltip } from '@snapchat/snap-design-system';
import { DEFAULT_TOOLTIP_DELAY } from '../../constants';
import { isEmptyString, isNil } from '../../util/object';
import { getDisplayNameForComponent } from '../../features/error/util';

const withTooltip = (WrappedComponent, defaultTooltip = null) => {
  class WithTooltip extends React.PureComponent {
    static defaultProps = {
      tooltip: defaultTooltip,
      tooltipDelay: DEFAULT_TOOLTIP_DELAY,
    };

    render() {
      const {
        arrowPointAtCenter,
        onClick,
        tooltip: message,
        tooltipDelay: delayShow,
        tooltipPlacement = 'top',
        ...restProps
      } = this.props;

      if (isNil(message) || isEmptyString(message) || !message) {
        return <WrappedComponent onClick={onClick} {...restProps} />;
      }

      /* If Tooltip Isn't Showing, it may be that WrappedComponent doesn't handle mouse events or pass them on correctly */
      return (
        <Tooltip
          arrowPointAtCenter={arrowPointAtCenter}
          content={message}
          mouseEnterDelay={delayShow}
          placement={tooltipPlacement}
        >
          <WrappedComponent {...restProps} onClick={this.wrappedClick} />
        </Tooltip>
      );
    }

    wrappedClick = (...args) => {
      const { onClick } = this.props;
      if (onClick) {
        onClick(...args);
      }
    };
  }

  WithTooltip.displayName = getDisplayNameForComponent(
    'WithTooltip',
    WrappedComponent,
  );

  return WithTooltip;
};

/**
  to be used as an annotation on components
  the components need to have onMouseOver and onMouseOut on its root element
**/
const tooltip = (defaultTooltip = null) => (target) => {
  return withTooltip(target, defaultTooltip);
};

export { tooltip, Tooltip };

export default withTooltip;
